module.exports = __webpack_public_path__ + "6b85d609001c2ff6b5a71422ee3181fe.svg";